export default __webpack_public_path__ + "static/filedblob-2726066d8cd119784a5436cfde4c8556.png";